const SafeProductionMge = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionMge')), 'SafeProductionMge');
const SafeProductionDatil = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionDatil/SafeProductionDatil')), 'SafeProductionDatil');
const SafeProductionList = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionList/SafeProductionList')), 'SafeProductionList');
const SafeProductionAdd = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionAdd/SafeProductionAdd')), 'SafeProductionAdd');
const SpecialInspectionAdd = r => require.ensure([], () => r(require('@/page/SafeProduction/SpecialInspectionAdd/SpecialInspectionAdd')), 'SpecialInspectionAdd');
const SafeProductionCensor = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionCensor/SafeProductionCensor')), 'SafeProductionCensor');
const SpecialInspectionCensor = r => require.ensure([], () => r(require('@/page/SafeProduction/SpecialInspectionCensor/SpecialInspectionCensor')), 'SpecialInspectionCensor');
const SafeProductionCheckList = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionCheckList/SafeProductionCheckList')), 'SafeProductionCheckList');
const SafeProductionCheckListXmjl = r => require.ensure([], () => r(require('@/page/SafeProduction/SafeProductionCheckListXmjl/SafeProductionCheckListXmjl')), 'SafeProductionCheckListXmjl');
const SafetyProductionTwoPage = r => require.ensure([], () => r(require('@/page/SafeProduction/SafetyProductionTwoPage/SafetyProductionTwoPage')), 'SafetyProductionTwoPage');
const ModifyProduction = r => require.ensure([], () => r(require('@/page/SafeProduction/ModifyProduction/ModifyProduction')), 'ModifyProduction'); //安全生产修改

// 安全隐患列表
const SafeDangerList = r => require.ensure(
  [],
  () => r(require('@/page/SafeProduction/SafeDanger/safe-danger-list.vue')),
  'SafeDangerList'
);

// 录入安全隐患
const SafeDangerSubmit = r => require.ensure(
  [],
  () => r(require('@/page/SafeProduction/SafeDanger/safe-danger-submit.vue')),
  'SafeDangerSubmit'
);

// 
// const DemoReport = r => require.ensure(
//   [],
//   () => r(require('@/page/SafeProduction/SafeDanger/demo-report.vue')),
//   'DemoReport'
// );

const SafeProductionRouter = {
  path: '',
  component: SafeProductionMge,
  meta: {
    icon: '',
    right: [],
    isShowMenu: false,
    keepAlive:true
  },
  name: '',
  redirect: '/SafeProductionMge',
  children: [
    // {
    //   path: '/DemoReport',
    //   component: DemoReport,
    //   name: '报表示例',
    //   meta: {
    //     right: [],
    //     name: '报表示例',
    //     isShowMenu: false,
    //     keepAlive: true,
    //     t:Date.now(),
    //   },
    // },
    {
      path: '/SafeDangerList',
      component: SafeDangerList,
      name: '安全隐患',
      meta: {
        right: [],
        name: '安全隐患',
        isShowMenu: false,
        keepAlive: false,
        t:Date.now(),
      },
    },
    {
      path: '/SafeDangerSubmit',
      component: SafeDangerSubmit,
      name: '录入安全隐患',
      meta: {
        right: [],
        name: '录入安全隐患',
        isShowMenu: false,
        keepAlive: false,
        t:Date.now(),
      },
    },
    {
      path: '/SafeDangerEdit',
      component: SafeDangerSubmit,
      name: '编辑安全隐患',
      meta: {
        right: [],
        name: '编辑安全隐患',
        isShowMenu: false,
        keepAlive: false,
        t:Date.now(),
      },
    },
    {
      path: '/SafeProductionList',
      component: SafeProductionList,
      name: '检查区域',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/SafetyProductionTwoPage',
      component: SafetyProductionTwoPage,
      name: '安全检查统计',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/SafeProductionCheckList',
      component: SafeProductionCheckList,
      name: '安全生产检查任务',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/SafeProductionCheckListXmjl',
      component: SafeProductionCheckListXmjl,
      name: '安全生产检查任务',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/SafeProductionDatil',
      component: SafeProductionDatil,
      name: '检查详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },

    }, {
      path: '/SafeProductionProcess',
      // component: SafeProductionAdd,
      name: '发起安全生产',
      meta: {
        right: [],
        isShowMenu: false,
        workflow: true,
        workTemplateName: '安全检查',
        keepAlive:true
      },
    }, {
      path: '/SpecialInspectionProcess',
      name: '发起专项检查',
      meta: {
        right: [],
        isShowMenu: false,
        workflow: true,
        workTemplateName: '专项检查',
        keepAlive:true
      },
    }, {
      path: '/SafeProductionAdd',
      component: SafeProductionAdd,
      name: '发起安全生产',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/SpecialInspectionAdd',
      component: SpecialInspectionAdd,
      name: '发起专项检查',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, {
      path: '/SpecialInspectionCensor',
      component: SpecialInspectionCensor,
      name: '专项检查审批',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },{
      path: '/SpecialInspectionCensorX',
      component: SpecialInspectionCensor,
      name: '专项检查发起',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/SafeProductionCensor',
      component: SafeProductionCensor,
      name: '安全生产审批',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },{
      path: '/SafeProductionCensorX',
      component: SafeProductionCensor,
      name: '安全生产详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },{
      path: '/ModifyProduction',
      component: ModifyProduction,
      name: '安全生产修改',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }
  ]
};

export default SafeProductionRouter;